export function getImageKey(image: App.Image, index: number): string {
  return image.id ?? image.url ?? index.toString()
}

export function dedupeImages(images: Array<App.Image>): Array<App.Image> {
  const seen = new Set<string>()
  return images.filter((image, index) => {
    const key = getImageKey(image, index)
    if (seen.has(key)) return false
    seen.add(key)
    return true
  })
}

export function formatRoomLabel(label: string): string {
  return label
    .replace(/\s*[^\p{L}\p{N}\s]+\s*/gu, ' ')
    .replace(/\s+/g, ' ')
    .trim()
}

export function groupImagesByTitle(images: Array<App.Image>): Map<string, Array<App.Image>> {
  const groups = new Map<string, Array<App.Image>>()

  images.forEach((image) => {
    if (!image.title) return
    const existing = groups.get(image.title)
    groups.set(image.title, existing ? [...existing, image] : [image])
  })

  return groups
}
